// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"9ca8f5bc","487":"9ca8f5bc","4664":"9ca8f5bc"}[chunkId] + ".chunk.css";
};